import React, { useState, useEffect, Fragment } from 'react';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonInput,
  IonItem,
  IonList,
  IonButton,
  IonLabel,
  IonText,
  IonLoading,
  IonCard,
  IonImg
} from '@ionic/react';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/userActions';
import _ from 'lodash';

const EditItemContainer: React.FC = (props: any) => {
  const { user, userDBInfo } = props;

  const [name, setName] = useState<string>();
  const [description, setDescription] = useState<string>();
  const [address, setAddress] = useState<string>();
  const [number, setNumber] = useState<string>();
  const [loading, setLoading] = useState<string>();

  const [imageData, setImageData] = useState<any>('');
  const [MIMEType, setMIMEType] = useState<string>('');

  function getImage64(e: any) {
    //read image datad
    let data;
    let FR = new FileReader();
    if (e) {
      FR.addEventListener('load', function (e) {
        //@ts-ignore
        data = e.target.result;
        setImageData(data);
      });
      FR.readAsDataURL(e);
      setMIMEType(e.type);
    }
  }

  try {
    useEffect(() => {
      setName(userDBInfo.shopName);
      setDescription(userDBInfo.shopDescription);
      setAddress(userDBInfo.address);
      setNumber(userDBInfo.number);
    }, [
      userDBInfo.shopName,
      userDBInfo.shopDescription,
      userDBInfo.address,
      userDBInfo.number,
    ]);
  } catch (e) {
    console.log('loaded on user edit');
  }

  if (!userDBInfo) {
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>Edit Profile</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard button={true} onClick={()=>{document?.getElementById('imageItem')?.click()}}>
          <IonImg src={ imageData? imageData : "assets/placeholder-image.jpg" }/>
        </IonCard>
        <IonList>
          <IonItem>
            <IonLabel position="stacked">
              Shop Name <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              value={name}
              onIonChange={(e) => setName(e.detail.value!)}
              clearInput
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Shop Description</IonLabel>
            <IonInput
              value={description}
              onIonChange={(e) => setDescription(e.detail.value!)}
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">
              Address <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              value={address}
              onIonChange={(e) => setAddress(e.detail.value!)}
            ></IonInput>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">
              Mobile Number <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput
              value={number}
              onIonChange={(e) => setNumber(e.detail.value!)}
              clearInput
            ></IonInput>
          </IonItem>

              <input
                type="file"
                id="imageItem"
                name="img"
                accept="image/*"
                onChange={(e: any) => getImage64(e.target.files[0])}
                hidden/>
              {/*             
              <IonItem>
              {!_.isEmpty(imageData) && (
                <img
                  src={imageData}
                  alt="uploaded item"
                  style={{ width: '100vw' }}
                />
              )}
            </IonItem>
            */}


          <IonButton
            expand="block"
            disabled={!(name && address && number)}
            onClick={() => {
              setLoading('loading...');
              props.onUpdateUser({
                shopName: name,
                shopDescription: description,
                address,
                number,
                email: user.email,
                imageData,
                MIMEType,
                imageURL: userDBInfo.imageURL,
              });
            }}
          >
            {loading || 'Save Changes'}
          </IonButton>
          <IonButton expand="block" color="danger" routerLink="/profile">
            Cancel
          </IonButton>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.userReducer.user,
    userDBInfo: state.userReducer.userDbInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onUpdateUser: (payload: {}) => dispatch(actionCreator.updateUser(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditItemContainer);
